import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, Input, Modal } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

function EditWorkflowModal() {
  const {
    mediaAssetStore,
    commonStore,
    viewStore: { activeOrder },
    userStore,
  } = useStore();

  const [isShowModal, setIsShowModal] = useState(false);
  const [value, setValue] = useState('');

  const onClickHandler = () => {
    setIsShowModal(true);
  };

  return (
    // <div>
    <>
      {isShowModal && (
        <Modal
          onClose={() => setIsShowModal(false)}
          onOpen={() => setIsShowModal(true)}
          open={isShowModal}
          style={{ maxWidth: '512px' }}
        >
          <Modal.Header>
            Edit Workflow
            <p
              style={{
                marginTop: '13px',
                fontSize: '14px',
                color: '#808080bf',
                letterSpacing: '.3px',
                fontWeight: 'normal',
              }}
            >
              Please enter the new work order number in-order to modify the
              workflow
            </p>
          </Modal.Header>
          <Modal.Content image>
            <Input
              value={value}
              onChange={(e) => setValue(e.currentTarget.value)}
              error={value.length === 0}
              require
              style={{
                height: '50px',
                width: '210px',
              }}
              placeholder="Change Order Number *"
            ></Input>
          </Modal.Content>
          <Modal.Actions>
            <Button
              disabled={!value}
              color="green"
              onClick={() => mediaAssetStore.editworkflowopen('edit')}
            >
              Continue
            </Button>
          </Modal.Actions>
        </Modal>
      )}
      {commonStore.filterModeTwo?.includes('SCB07') ||
      commonStore.filterModeTwo?.includes('AVLAVB02') ? (
        <></>
      ) : (
        (userStore.user?.customerName !== 'NFAI' ||
          window.innerWidth > 1025 ||
          window.innerWidth < 1020) && (
          <Button
            className="edit-button"
            disabled={
              (commonStore.filterModeOne.includes('AVLAVB02') &&
                activeOrder.templateId === '') ||
              commonStore.filterModeZero?.includes('SCB07')
            }
            onClick={onClickHandler}
            color="blue"
          >
            {
              (userLanguage[0].AssetViewItemLevelAllAssetsView.AVLAVB02 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Button>
        )
      )}
    </>
  );
}

export default observer(EditWorkflowModal);
